module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.8b6957a.woff2";